import Attraction from './Attraction';

export default Attraction;